import { useRoles } from "../hooks/useRoles";
import { Navigate } from "react-router-dom";
import { focusOcApps } from "./sideBarItems";

export const HomeRedirect: React.FC = () => {
  const { roles } = useRoles();

  const accessibleRoutes = focusOcApps.filter((route) =>
    route.required.some((r) => [...roles].includes(r))
  );

  if (accessibleRoutes.length === 0) {
    return <Navigate to="/403" replace />;
  }

  return <Navigate to={accessibleRoutes[0].link} replace />;
};
